/* LEDPLANET lp-verzendland.js (28-10-2026, eigenaar: 'verzending gratis klopt niet', 'check ook alle andere landen')
   Eén land voor alle verzendteksten op de site: het bezorgland uit de centrale levertijd (LP_LEVERTIJD.land(): ?lp_land= om te testen,
   anders het gekozen bezorgland, de Shopify-markt of de locatie), met het Shopify-land als reserve.
   Voorheen volgde de blauwe USP-balk dat bezorgland, maar de productkaarten en de winkelwagenmelding het Shopify-land (en de groene
   balk op de productpagina ook): bezorgland Duitsland in de Nederlandse markt gaf dan 'Kostenloser Versand ab 100 Euro' bovenin
   en 'Kostenloser Versand' bij een artikel van 60,95.
   Dit bestand regelt:
   1. blauwe USP-balk: punt 1 en 2 volgens de zone van het land (teksten per zone staan als data-lp-z-* in snippets/ledplanet-huisstijl)
   2. productkaarten: 'Gratis verzending' alleen als de prijs boven de grens van het land ligt (snippets/ledplanet-kaart-verzending)
   3. winkelwagen (lade en pagina): melding gratis verzending / minimaal bestelbedrag (snippets/free-shipping-notice)
   De groene balk op de productpagina (assets/lp-gratis-verzending.js) gebruikt hetzelfde land.
   GRENZEN = Instellingen > Verzending: NL/BE gratis vanaf 50 (4,95) | DE gratis vanaf 100 (8,95) |
   zone Europa gratis vanaf 150, 9,95 vanaf 100, daaronder geen verzending | overige landen: geen verzendtarief.
   Geladen vanuit snippets/ledplanet-huisstijl (defer, elke pagina). */
(function () {
  var EU = 'AT BG HR CZ DK EE FI FR GR HU IE IT LV LT LU MT NO PL PT RO SK SI ES SE CH GB'.split(' ');
  function land() {
    var c = null;
    try { c = window.LP_LEVERTIJD && window.LP_LEVERTIJD.land && window.LP_LEVERTIJD.land(); } catch (e) {}
    return String(c || (window.Shopify && window.Shopify.country) || 'NL').toUpperCase();
  }
  function grens(c) {
    if (c === 'NL' || c === 'BE') return { g: 50, m: 0, z: 'gratis' };
    if (c === 'DE') return { g: 100, m: 0, z: 'de' };
    if (EU.indexOf(c) > -1) return { g: 150, m: 100, z: 'eu' };
    return null;   // geen verzendtarief voor dit land
  }
  window.LP_VZ = { land: land, grens: grens };

  function rate() { try { return parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1; } catch (e) { return 1; } }
  var TAAL = ((document.documentElement.lang || 'nl').slice(0, 2)).toLowerCase();
  var LOC = document.documentElement.lang || 'nl-NL';
  var EW = { nl: 'euro', de: 'Euro', en: 'euros', fr: 'euros', es: 'euros', it: 'euro', pl: 'euro' };
  function geld(cent) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', v = cent / 100, s;
    try { s = new Intl.NumberFormat(LOC, { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); } catch (e) { s = v.toFixed(2).replace('.', ','); }
    return s + ' ' + (cur === 'EUR' ? (EW[TAAL] || 'euro') : cur);
  }
  function naam(c) { try { return new Intl.DisplayNames([TAAL], { type: 'region' }).of(c) || c; } catch (e) { return c; } }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // 1. blauwe USP-balk
  function balk(gr) {
    var z = gr ? gr.z : 'eu';
    document.querySelectorAll('.lp-uspbar li[data-lp-z-gratis]').forEach(function (li) {
      if (li.getAttribute('data-lp-z-nu') === z) return;
      var t = li.getAttribute('data-lp-z-' + z); if (t == null) return;
      // nieuwe tekstnode (geen nodeValue): lp-site.js onthoudt de oorspronkelijke tekst per node
      var oud = li.lastChild, nieuw = document.createTextNode(t);
      if (oud && oud.nodeType === 3) li.replaceChild(nieuw, oud); else li.appendChild(nieuw);
      li.setAttribute('data-lp-z-nu', z);
    });
  }
  // 2. productkaarten
  function kaarten(gr) {
    var gc = gr ? Math.round(gr.g * 100 * rate()) : 0;
    document.querySelectorAll('.lp-kv[data-kv-prijs]').forEach(function (el) {
      var ok = !!gr && +el.getAttribute('data-kv-prijs') >= gc;
      if (el.hidden === ok) el.hidden = !ok;
      var d = ok ? '' : 'none';
      if (el.style.display !== d) el.style.display = d;
    });
  }
  // 3. winkelwagen
  function wagen(gr, c) {
    document.querySelectorAll('.free-shipping-notice[data-lp-tot]').forEach(function (el) {
      var tot = +el.getAttribute('data-lp-tot') || 0;
      var sleutel = c + '/' + tot;
      if (el.getAttribute('data-lp-nu') === sleutel) return;
      el.setAttribute('data-lp-nu', sleutel);
      if (el.getAttribute('data-lp-leeg') === '1' || !gr) { el.innerHTML = ''; return; }
      var r = rate(), gc = Math.round(gr.g * 100 * r), mc = Math.round(gr.m * 100 * r);
      var cs = el.getAttribute('data-lp-cs') || '', start = el.hasAttribute('data-lp-start'), boven = el.hasAttribute('data-lp-boven');
      function blok(kop, pct, min) {
        var bar = '<div class="free-shipping-notice__bar ' + (boven ? 'mb-3' : 'mt-3') + '" style="--progress: ' + Math.min(100, pct).toFixed(2) + '%"></div>';
        return '<div class="free-shipping-container' + cs + '"><div class="block' + (start ? '' : ' mx-auto') + ' text-theme-heading"' + (min ? '' : ' data-minimum="' + gc + '"') + '>' +
          (boven ? bar : '') + '<div class="free-shipping-notice__heading mb-2' + (start ? '' : ' text-center') + '">' + kop + '</div>' + (boven ? '' : bar) + '</div></div>';
      }
      var html;
      if (mc > 0 && tot < mc) {
        html = blok((el.getAttribute('data-lp-t-min') || '').replace('[c]', esc(naam(c))).replace('[x]', esc(geld(mc - tot))), tot / mc * 100, true);
      } else if (tot >= gc) {
        html = blok('<strong>' + esc(el.getAttribute('data-lp-t-gratis') || '') + '</strong>', 100);
      } else {
        html = blok((el.getAttribute('data-lp-t-nog') || '').replace('[x]', esc(geld(gc - tot))), tot / gc * 100);
      }
      el.innerHTML = html;
    });
  }
  function alles() {
    var c = land(), gr = grens(c);
    try { balk(gr); } catch (e) {}
    try { kaarten(gr); } catch (e) {}
    try { wagen(gr, c); } catch (e) {}
  }
  window.LP_VZ.ververs = alles;
  var gepland = false;
  function later() { if (gepland) return; gepland = true; requestAnimationFrame(function () { gepland = false; alles(); }); }
  function start() {
    alles();
    setTimeout(alles, 600); setTimeout(alles, 1600);
    document.addEventListener('lp:levertijd-update', function () { setTimeout(alles, 40); });
    // later geladen kaarten (aanbevelingen, zoeken, filters) en een opnieuw opgebouwde winkelwagen
    if (window.MutationObserver) new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
